import CustomSelect from "../common/CustomSelect";
import InputField from "../common-managment/InputField";
import DateInputField from "../common-managment/DateInputField";
import save from "../../assets/icons/save.svg";
import { RiCloseLargeFill } from "react-icons/ri";
import FileInput from "../common-managment/FileInput";

export default function EditAddData({
  data,
  setData,
  handleSave,
  setAddRowForm,
}) {
  // ✅ Generic change handler for text/date
  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  // ✅ File change handler
  const handleFileChange = (field, file) => {
    setData((prev) => ({ ...prev, [field]: file }));
  };

  return (
    <tr className="text-[#242424] divide-x divide-[#323649] border-t border-[#323649] bg-[#D7EFFF]">
      <td className="px-5 py-[9px]"></td>
      <td className="px-5 py-[9px]"></td>

      {/* Project Name */}
      <td className="px-[5px] py-1">
        <InputField
          placeholder="프로젝트 이름"
          value={data?.project_name}
          onChange={(e) => handleChange("project_name", e.target.value)}
        />
      </td>

      {/* Start Date */}
      <td className="px-[5px] py-1">
        <DateInputField
          placeholder="시작일"
          value={data?.start_date}
          onChange={(e) => handleChange("start_date", e.target.value)}
        />
      </td>

      {/* End Date */}
      <td className="px-[5px] py-1">
        <DateInputField
          placeholder="종료일"
          value={data?.end_date}
          onChange={(e) => handleChange("end_date", e.target.value)}
        />
      </td>

      {/* Description */}
      <td className="px-[5px] py-1">
        <InputField
          placeholder="설명"
          value={data?.description}
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </td>

      {/* Tab */}
      <td className="px-5 py-1.5">
        <CustomSelect
          label="탭"
          value={data?.tab}
          options={["I3D", "WebGL", "홍보"]}
          onSelect={(val) => handleChange("tab", val)}
        />
      </td>

      {/* Dev Type */}
      <td className="px-5 py-1.5">
        <CustomSelect
          label="개발 타입"
          value={data?.dev_type}
          options={["ISS", "Node.js", "Javascript", "Unity"]}
          multiple
          onSelect={(val) => handleChange("dev_type", val)}
        />
      </td>

      {/* URL */}
      <td className="px-[5px] py-1">
        <InputField
          placeholder="URL"
          value={data?.url}
          onChange={(e) => handleChange("url", e.target.value)}
        />
      </td>

      {/* Representative Image */}
      <td className="px-5 py-[5px]">
        <FileInput
          id="representative_image"
          file={data?.representative_image}
          onChange={(file) => handleFileChange("representative_image", file)}
        />
      </td>

      {/* Related Documents */}
      <td className="px-5 py-[5px]">
        <FileInput
          id="related_documents"
          file={data?.related_documents}
          onChange={(file) => handleFileChange("related_documents", file)}
        />
      </td>

      {/* Related Video */}
      <td className="px-5 py-[5px]">
        <FileInput
          id="related_video"
          file={data?.related_video}
          onChange={(file) => handleFileChange("related_video", file)}
        />
      </td>

      {/* Actions */}
      <td className="px-5 py-[9px]">
        <div className="flex items-center gap-7 justify-center w-[80px] mx-auto">
          <button
            onClick={() => {
              handleSave();
              setAddRowForm(false);
            }}
          >
            <img src={save} alt="save" className="w-4 h-4" />
          </button>
          <button onClick={() => setAddRowForm(false)}>
            <RiCloseLargeFill size={14} color="#242424" />
          </button>
        </div>
      </td>
    </tr>
  );
}
